import { createContext } from 'react';
export const PDFDataContext = createContext(null);
